export default __webpack_public_path__ + "static/FS2S-InHub-20-e913644c53607697d1425bd7ea71a930.jpg";